import React from 'react';
import classNames from 'classnames';

import Icon from 'components/ui/Icon';
import BadgeWrapper from './BadgeWrapper';

type LoginMethodButtonProps = {
  className?: string;
  iconName?: string;
  testId?: string;
  onClick: () => void;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  badgeLabel?: React.ReactNode;
};

const LoginMethodButton: React.FC<LoginMethodButtonProps> = ({
  title,
  testId,
  onClick,
  subtitle,
  iconName,
  className,
  badgeLabel,
}) => (
  <BadgeWrapper badgeLabel={badgeLabel} iconName={iconName} className={className}>
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={classNames(
        'flex-1 min-h-52 bg-card-bg rounded-card',
        'flex flex-col items-center justify-center gap-m px-s py-2xl',
        'hover:brightness-95 transition-all',
      )}
    >
      <span className="font-semibold text-center text-s">{title}</span>
      <div className="flex items-center gap-1 text-s text-btn-secondary-text">
        {subtitle}
        <Icon className="fb-icon--arrow-right text-s" />
      </div>
    </button>
  </BadgeWrapper>
);

export default LoginMethodButton;
